/** MYAC-1607 — the watched list's optional columns, in table order. The
 *  designation and the row menu are always shown. */
export type ListColumnKey = 'category' | 'edition' | 'title' | 'normative_body' | 'status' | 'tracking' | 'verification'
export const LIST_COLUMNS: readonly ListColumnKey[] = Object.freeze([
  'category',
  'edition',
  'title',
  'normative_body',
  'status',
  'tracking',
  'verification',
])
/** What a list shows until its user picks: the table fits a 1440 px screen.
 *  The edition then reads under the designation, its « Choose an edition »
 *  included; the organisation and the review date are one click away. */
export const DEFAULT_LIST_COLUMNS: readonly ListColumnKey[] = Object.freeze(['category', 'title', 'status', 'verification'])
